/* eslint-disable array-callback-return */
import _ from "lodash";
import { store } from "..";
import {
	setFacilityPercentage,
	setFilterTotal,
	setIsCensusTotalLocked,
	setLockedByFacility,
	setLockedTotalBy,
	setLockTotal,
} from "../store/reducers/community-transfer.slice";
import {
	setFacilityPercentage as setFacilityPercentageComparison,
	setFilterTotal as setFilterTotalComparison,
	setIsCensusTotalLocked as setIsCensusTotalLockedComparison,
	setLockedByFacility as setLockedByFacilityComparison,
	setLockedTotalBy as setLockedTotalByComparison,
	setLockTotal as setLockTotalComparison,
} from "../store/reducers/comparisonReducers/communityTransferComparison.slice";
import { TOTAL_TYPE, CUSTOM_TAB_TYPE } from "../types/common.type";
import { CO_TRANSFER_CARDS_TYPE, COMMUNITY_CARD_LABELS, TRANSFER_TYPE } from "../types/community-transfer.type";
import { dynamicCardFilter, filterCustomPatientData, filterListDataItems, getDynamicPercentageBy, processDynamicCard, updateListTotalValue } from "./common";
import { batch } from "react-redux";
import { getCustomTabsCards } from "./custom-tab-filter";
import { daysData, doctorData, floorsData, insuranceData, ninetyDaysDataList, returnsData } from "./hospital-common";
import { PAGE_TYPE } from "../types/pages.type";

// Attach level1/level2/level3/level4/level5 totals to list items for tooltip only (non-mutating calculations).
const attachLevelTotals = (list, snapshots, currentLevel, getKey, cardTitles = {}) => {
	if (!Array.isArray(list) || currentLevel < 2 || !snapshots) return list;
	const level1 = Array.isArray(snapshots.level1) ? snapshots.level1 : [];
	const level2 = Array.isArray(snapshots.level2) ? snapshots.level2 : [];
	const level3 = Array.isArray(snapshots.level3) ? snapshots.level3 : [];
	const level4 = Array.isArray(snapshots.level4) ? snapshots.level4 : [];
	const level5 = Array.isArray(snapshots.level5) ? snapshots.level5 : [];
	return list.map((item) => {
		// Preserve existing level totals if they're already set (e.g., from dxData, shiftData)
		if (item.level1Total !== undefined || item.level2Total !== undefined || item.level3Total !== undefined || item.level4Total !== undefined || item.level5Total !== undefined) {
			return {
				...item,
				...(currentLevel >= 2 && cardTitles.level1 && { level1CardTitle: cardTitles.level1 }),
				...(currentLevel >= 3 && cardTitles.level2 && { level2CardTitle: cardTitles.level2 }),
				...(currentLevel >= 4 && cardTitles.level3 && { level3CardTitle: cardTitles.level3 }),
				...(currentLevel >= 5 && cardTitles.level4 && { level4CardTitle: cardTitles.level4 }),
				...(currentLevel >= 6 && cardTitles.level5 && { level5CardTitle: cardTitles.level5 }),
			};
		}
		const key = getKey(item);
		if (key === undefined || key === null) return item;
		const level1Total = level1.filter((p) => getKey(p) === key).length;
		const level2Total = level2.filter((p) => getKey(p) === key).length;
		const level3Total = level3.filter((p) => getKey(p) === key).length;
		const level4Total = level4.filter((p) => getKey(p) === key).length;
		const level5Total = level5.filter((p) => getKey(p) === key).length;
		return {
			...item,
			...(currentLevel >= 2 && { level1Total }),
			...(currentLevel >= 3 && { level2Total }),
			...(currentLevel >= 4 && { level3Total }),
			...(currentLevel >= 5 && { level4Total }),
			...(currentLevel >= 6 && { level5Total }),
			...(currentLevel >= 2 && cardTitles.level1 && { level1CardTitle: cardTitles.level1 }),
			...(currentLevel >= 3 && cardTitles.level2 && { level2CardTitle: cardTitles.level2 }),
			...(currentLevel >= 4 && cardTitles.level3 && { level3CardTitle: cardTitles.level3 }),
			...(currentLevel >= 5 && cardTitles.level4 && { level4CardTitle: cardTitles.level4 }),
			...(currentLevel >= 6 && cardTitles.level5 && { level5CardTitle: cardTitles.level5 }),
		};
	});
};

// Helper to attach level totals when result is an array; keeps original data intact.
const maybeAttachTotals = (dataArr, snapshots, currentLevel, keySelector, cardTitles = {}) => {
	if (!Array.isArray(dataArr)) return dataArr;
	return attachLevelTotals(dataArr, snapshots, currentLevel, keySelector, cardTitles);
};

// * added comparison
export async function updateFacilityPercentageTotal(data, forComparison) {
	let facilityWiseTotal = _(data)
		.groupBy("facilityId")
		.sortBy((group) => data.indexOf(group[0]))
		.map((product) => {
			return {
				id: product[0]?.facilityId,
				total: product.length || 0,
			};
		})
		.value();
	forComparison
		? store.dispatch(setFacilityPercentageComparison(facilityWiseTotal))
		: store.dispatch(setFacilityPercentage(facilityWiseTotal));
}

export async function plannedFilter(patientData, oldFilter, type = null) {
	patientData = _.filter(patientData, ({ floorId, doctorId, snfFacilityId, insuranceId, assistantLivId }) => {
		let filterArr = [];

		if (oldFilter.insuranceData.length > 0 && type !== "insuranceData") {
			filterArr.push(_.includes(oldFilter.insuranceData, insuranceId));
		}
		if (oldFilter.doctorData.length > 0 && type !== "doctorData") {
			filterArr.push(_.includes(oldFilter.doctorData, doctorId));
		}
		if (oldFilter.floorsData.length > 0 && type !== "floorsData") {
			filterArr.push(_.includes(oldFilter.floorsData, floorId));
		}
		if (oldFilter.snfFacilityData.length > 0 && type !== "snfFacilityData") {
			filterArr.push(_.includes(oldFilter.snfFacilityData, snfFacilityId));
		}
		if (oldFilter.safeDischargeAssLivData.length > 0 && type !== "safeDischargeAssLivData") {
			if (!_.includes(oldFilter.safeDischargeAssLivData, "all")) {
				filterArr.push(_.includes(oldFilter.safeDischargeAssLivData, assistantLivId));
			}
		}
		return _.every(filterArr);
	});
	return patientData;
}

function returnsDataFilter(oldFilter) {
	if (oldFilter.returnsData[0] === "Returned") {
		return true;
	}
	if (oldFilter.returnsData[0] === "Didn't Return") {
		return false;
	}
}

// * added comparison
export async function updateFilterListData(cardFilter, patientList, priorityData = [], transferType, forComparison) {
	const { list = [], sixtyDaysData, diffDashboardPatients } = patientList || {};
	const {
		dbData,
		lockedTotal,
		lockedTotalBy
	} = forComparison ? store.getState().communityTransferComparison : store.getState().communityTransfer;
	const { dynamicCards: storeDynamicCards } = store.getState().communityTransfer;
	const dynamicCards = patientList?.dynamicCards ?? storeDynamicCards;
	let censusAverage = dbData?.censusAverage;
	const customTabs = patientList?.customTabs ?? [];
	const customCombineTabData = patientList?.customCombineTabData ?? [];

	if (!forComparison) {
		censusAverage = await getDynamicPercentageBy(dbData);
	}

	let objectCustom = Object();
	let newSavedFilters = [];
	let patientFilterData = list;
	let filter1 = Object();
	let mainNumPercentage = censusAverage;
	let isComparingAgainstAvgCensus = true;

	const transferTypeConsumesLevel = transferType?.length > 0 && !_.includes(transferType, TRANSFER_TYPE.ALL);
	const activeFiltersCount = priorityData ? priorityData.filter(e => e.type !== "census" && e.type !== "total" && e.type !== TRANSFER_TYPE.ALL && !e.type?.toLowerCase().includes("total")).length : 0;

	let totalFilterData = {
		originalData: patientFilterData,
		totalType: !forComparison ? (transferTypeConsumesLevel || activeFiltersCount > 0) ? TOTAL_TYPE.FILTER : TOTAL_TYPE.MAIN : TOTAL_TYPE.MAIN,
		totalForPercentage: censusAverage,
	};
	let lockedTotalModified = lockedTotal;

	batch(async () => {
		if (!lockedTotalModified) {
			const newLockedTotalBy = null;
			if (forComparison) {
				const currentLockedTotalBy = store.getState().communityTransferComparison.lockedTotalBy;
				if (!_.isEqual(currentLockedTotalBy, newLockedTotalBy)) {
					store.dispatch(setLockedTotalByComparison(newLockedTotalBy))
				}
			} else {
				const currentLockedTotalBy = store.getState().communityTransfer.lockedTotalBy;
				if (!_.isEqual(currentLockedTotalBy, newLockedTotalBy)) {
					store.dispatch(setLockedTotalBy(newLockedTotalBy))
				}
			}
		}
		if (transferType.length > 0) {
			mainNumPercentage = null;
			if (!_.includes(transferType, TRANSFER_TYPE.ALL)) {
				patientFilterData = patientFilterData
					.map((item) => {
						if (_.includes(transferType, item.transferType)) {
							return item;
						}
					})
					.filter((item) => item);
			}
			isComparingAgainstAvgCensus = false;
			totalFilterData.totalForPercentage = patientFilterData.length;
		}

		if (lockedTotalModified) {
			// if (priorityData.length > 1) {
			//   mainNumPercentage = null;
			// }
			totalFilterData.totalForPercentage = lockedTotalModified;
		}

		if (lockedTotalBy) {
			const newLockedTotalBy = null;
			const newLockTotal = null;
			if (
				lockedTotalBy === TRANSFER_TYPE.SAFE_DISCHARGE ||
				lockedTotalBy === TRANSFER_TYPE.SNF ||
				lockedTotalBy === TRANSFER_TYPE.AMA ||
				lockedTotalBy === TRANSFER_TYPE.ALL ||
				lockedTotalBy === "census"
			) {
				// Old conditions
				// if (lockedTotalBy === "transferType" || lockedTotalBy === "census") {
				// 	if (lockedTotalModified && lockedTotalBy !== "census") {
				// 		forComparison ? store.dispatch(setLockedTotalByComparison(null)) : store.dispatch(setLockedTotalBy(null));
				// 		forComparison ? store.dispatch(setLockTotalComparison(null)) : store.dispatch(setLockTotal(null));
				// 		lockedTotalModified = null;
				// 	}
				// }
				if (lockedTotalModified && transferType.length === 0 && lockedTotalBy !== "census") {
					if (forComparison) {
						const currentLockedTotalBy = store.getState().communityTransferComparison.lockedTotalBy;
						if (!_.isEqual(currentLockedTotalBy, newLockedTotalBy)) {
							store.dispatch(setLockedTotalByComparison(newLockedTotalBy))
						}
					} else {
						const currentLockedTotalBy = store.getState().communityTransfer.lockedTotalBy;
						if (!_.isEqual(currentLockedTotalBy, newLockedTotalBy)) {
							store.dispatch(setLockedTotalBy(newLockedTotalBy))
						}
					}

					if (forComparison) {
						const currentLockedTotal = store.getState().communityTransferComparison.lockedTotal;
						if (!_.isEqual(currentLockedTotal, newLockTotal)) {
							store.dispatch(setLockTotalComparison(newLockTotal))
						}
					} else {
						const currentLockedTotal = store.getState().communityTransfer.lockedTotal;
						if (!_.isEqual(currentLockedTotal, newLockTotal)) {
							store.dispatch(setLockTotal(newLockTotal))
						}
					}

					lockedTotalModified = null;
				}
				if (!lockedTotalModified) {
					forComparison ? store.dispatch(setLockedTotalByComparison(null)) : store.dispatch(setLockedTotalBy(null));
					forComparison ? store.dispatch(setLockTotalComparison(null)) : store.dispatch(setLockTotal(null));
					lockedTotalModified = null;
				}
			} else {
				const lockedFilterRemoved = _.find(priorityData, { type: lockedTotalBy });
				if (!lockedFilterRemoved) {
					if (forComparison) {
						const currentLockedTotalBy = store.getState().communityTransferComparison.lockedTotalBy;
						if (!_.isEqual(currentLockedTotalBy, newLockedTotalBy)) {
							store.dispatch(setLockedTotalByComparison(newLockedTotalBy))
						}
					} else {
						const currentLockedTotalBy = store.getState().communityTransfer.lockedTotalBy;
						if (!_.isEqual(currentLockedTotalBy, newLockedTotalBy)) {
							store.dispatch(setLockedTotalBy(newLockedTotalBy))
						}
					}

					if (forComparison) {
						const currentLockedTotal = store.getState().communityTransferComparison.lockedTotal;
						if (!_.isEqual(currentLockedTotal, newLockTotal)) {
							store.dispatch(setLockTotalComparison(newLockTotal))
						}
					} else {
						const currentLockedTotal = store.getState().communityTransfer.lockedTotal;
						if (!_.isEqual(currentLockedTotal, newLockTotal)) {
							store.dispatch(setLockTotal(newLockTotal))
						}
					}

					lockedTotalModified = null;
				}
			}
		}
		const newPayload = [];
		if (forComparison) {
			const currentFacilityPercentage = store.getState().communityTransferComparison.facilityPercentage;
			if (!_.isEqual(currentFacilityPercentage, newPayload)) {
				store.dispatch(setFacilityPercentageComparison(newPayload))
			}
		} else {
			const currentFacilityPercentage = store.getState().communityTransfer.facilityPercentage;
			if (!_.isEqual(currentFacilityPercentage, newPayload)) {
				store.dispatch(setFacilityPercentage(newPayload))
			}
		}


		if (!lockedTotalModified) {
			const newSetIsCensusTotalLocked = false;
			if (forComparison) {
				const currentIsCensusTotalLocked = store.getState().communityTransferComparison.isCensusTotalLocked;
				if (!_.isEqual(currentIsCensusTotalLocked, newSetIsCensusTotalLocked)) {
					store.dispatch(setIsCensusTotalLockedComparison(newSetIsCensusTotalLocked))
				}
			} else {
				const currentIsCensusTotalLocked = store.getState().communityTransfer.isCensusTotalLocked;
				if (!_.isEqual(currentIsCensusTotalLocked, newSetIsCensusTotalLocked)) {
					store.dispatch(setIsCensusTotalLocked(newSetIsCensusTotalLocked));
				}
			}
		}

		if (priorityData.length > 0) {
			isComparingAgainstAvgCensus = false;
		}

		if (
			(priorityData?.length > 0 && (!lockedTotalBy || !lockedTotal)) ||
			(priorityData?.length > 0 &&
				lockedTotalBy !== "census" &&
				lockedTotalBy !== TRANSFER_TYPE.SAFE_DISCHARGE &&
				lockedTotalBy !== TRANSFER_TYPE.SNF &&
				lockedTotalBy !== TRANSFER_TYPE.AMA &&
				lockedTotalBy !== TRANSFER_TYPE.ALL)
		) {
			totalFilterData.totalForPercentage = null;
		}
	});

	let dynamicCardsObj = {}; // 
	let customTabsObj = {};
	
	// Collect intermediate patient sets before each filter is applied (for tooltip only).
	// This does not change any existing calculations; it's read-only data for UI.
	const intermediateTotals = {};
	const cardTitles = {};
	
	// If transferType is selected (array with length > 0), store it as level1 before priorityData loop
	if (transferType.length > 0 && !_.includes(transferType, TRANSFER_TYPE.all)) {
		intermediateTotals.level1 = _.cloneDeep(patientFilterData);
		
		// Get transferType label from COMMUNITY_CARD_LABELS
		// If array contains ALL, use "Total", otherwise combine labels or use first one
		let transferTypeLabel = '';
		if (_.includes(transferType, TRANSFER_TYPE.ALL)) {
			transferTypeLabel = COMMUNITY_CARD_LABELS.total || "Total";
		} else if (transferType.length === 1) {
			// Single transfer type selected
			const type = transferType[0];
			if (type === TRANSFER_TYPE.SAFE_DISCHARGE) {
				transferTypeLabel = COMMUNITY_CARD_LABELS.safeDischarge || "Safe Discharges";
			} else if (type === TRANSFER_TYPE.SNF) {
				transferTypeLabel = COMMUNITY_CARD_LABELS.SNF || "SNF Transfers";
			} else if (type === TRANSFER_TYPE.AMA) {
				transferTypeLabel = COMMUNITY_CARD_LABELS.AMA || "AMA";
			} else {
				transferTypeLabel = type;
			}
		} else {
			// Multiple transfer types selected - combine labels
			const labels = transferType.map(type => {
				if (type === TRANSFER_TYPE.SAFE_DISCHARGE) return COMMUNITY_CARD_LABELS.safeDischarge || "Safe Discharges";
				if (type === TRANSFER_TYPE.SNF) return COMMUNITY_CARD_LABELS.SNF || "SNF Transfers";
				if (type === TRANSFER_TYPE.AMA) return COMMUNITY_CARD_LABELS.AMA || "AMA";
				return type;
			});
			transferTypeLabel = labels.join(" / ");
		}
		cardTitles.level1 = `${transferTypeLabel} total`;
	}
	
	// Calculate final level for remaining cards (accounts for transferType and active priority filters)
	const finalLevel = activeFiltersCount + (transferTypeConsumesLevel ? 1 : 0);
	
	if (priorityData.length > 0) {
		let i = 0;
		let currentValidFilterIndex = 0;
		let previousValidTitle = '';
		// Adjust starting level based on whether transferType is selected
		const levelOffset = transferTypeConsumesLevel ? 1 : 0;
		
		for await (const ele of priorityData) {
			i++;
			if (priorityData.length === i && lockedTotalModified && !lockedTotalBy) {
				forComparison
					? store.dispatch(setLockedTotalByComparison(ele.type))
					: store.dispatch(setLockedTotalBy(ele.type));
			}

			const isTotalLock = ele.type === "census" || ele.type === "total" || ele.type === TRANSFER_TYPE.ALL || ele.type?.toLowerCase().includes("total");

			if (!isTotalLock) {
				currentValidFilterIndex++;
				
				// Store snapshot BEFORE applying the current filter so downstream cards can show level totals.
				if (currentValidFilterIndex > 1 && currentValidFilterIndex <= 6) {
					const actualLevel = (currentValidFilterIndex - 1) + levelOffset;
					if (actualLevel >= 1 && actualLevel <= 5) {
						intermediateTotals[`level${actualLevel}`] = _.cloneDeep(patientFilterData);
						cardTitles[`level${actualLevel}`] = previousValidTitle ? `${previousValidTitle} total` : '';
					}
				}
				previousValidTitle = ele?.cardTitle || ele?.type || '';
			}
			
			// Calculate actualLevel for use in downstream card processing
			const actualLevel = currentValidFilterIndex + levelOffset;

		const totalCountData = mainNumPercentage && i === 1 ? mainNumPercentage : totalFilterData.totalForPercentage;

			if (ele?.question?.isCustom) {
				const customTabsRes = customTabs.filter((x) => x.accessor === ele.type);
				if (customTabsRes.length > 0) {
					// For combineTab: Always use mainNumPercentage (original data length before filters) to keep percentage consistent
					// For other custom cards: Use mainNumPercentage when i === 1 (first selected card) to preserve original percentage calculation
					// This matches the pattern used for default cards (e.g., insuranceData, doctorData, etc.)
					const isCombineTab = ele?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab;
					// For combineTab: Always use mainNumPercentage (original data length before filters)
					// If mainNumPercentage is not available, use originalData.length as fallback (originalData is the unfiltered data)
					// This ensures percentage is always calculated based on original data length, not filtered data
					const originalDataLength = totalFilterData?.originalData?.length || patientFilterData.length;
					const totalForPercentage = isCombineTab 
						? (mainNumPercentage || originalDataLength || totalFilterData.totalForPercentage)
						: (mainNumPercentage && i === 1 ? mainNumPercentage : totalFilterData.totalForPercentage);
					
					const isCheckNewFilters = true;
					customTabsObj = await getCustomTabsCards(
						patientFilterData, 
						customTabsRes, 
						{...totalFilterData, originalData: totalFilterData.originalData || patientFilterData, totalType: TOTAL_TYPE.FILTER, totalForPercentage, intermediateTotals, currentLevel: actualLevel, cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }, forComparison}, 
						{ sixtyDaysData, dynamicCards, pageType: PAGE_TYPE.COMMUNITY_TRANSFER, diffDashboardPatients, forComparison, customCombineTabData, isCheckNewFilters, newSavedFilters: [...newSavedFilters, ele.type] }
					);
				}
				objectCustom = { ...objectCustom, ...dynamicCardsObj, ...customTabsObj }
				patientFilterData = filterCustomPatientData(patientFilterData, cardFilter, ele);
			}

			if (ele.type === CO_TRANSFER_CARDS_TYPE.INSURANCE_DATA) {
				objectCustom.insuranceData = await insuranceData(patientFilterData, {
					...totalFilterData,
					totalForPercentage: totalCountData,
					intermediateTotals,
					currentLevel: actualLevel,
					cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
				});
				objectCustom.insuranceData = attachLevelTotals(
					objectCustom.insuranceData,
					{ level1: intermediateTotals.level1, level2: intermediateTotals.level2, level3: intermediateTotals.level3, level4: intermediateTotals.level4, level5: intermediateTotals.level5 },
					actualLevel,
					(p) => p.insuranceId ?? p._id ?? p.id,
					{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
				);

				patientFilterData = _.filter(patientFilterData, ({ insuranceId }) =>
					_.every([_.includes(cardFilter.insuranceData, insuranceId)])
				);
			}

			if (ele.type === CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA) {
				objectCustom.sixtyDaysData = await sixtyDaysDataList(sixtyDaysData, patientFilterData, {
					...totalFilterData,
					totalForPercentage: totalCountData,
					intermediateTotals,
					currentLevel: actualLevel,
					cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
				});
				objectCustom.sixtyDaysData = maybeAttachTotals(
					objectCustom.sixtyDaysData,
					{ level1: intermediateTotals.level1, level2: intermediateTotals.level2, level3: intermediateTotals.level3, level4: intermediateTotals.level4, level5: intermediateTotals.level5 },
					actualLevel,
					(p) => p._id ?? p.id,
					{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
				);

				if (i === priorityData.length) {
					updateFacilityPercentageTotal(patientFilterData, forComparison);
				}
				patientFilterData = await sixtyDaysDataFilter(cardFilter.sixtyDaysData, patientFilterData, sixtyDaysData);
			}
			if (ele.type === CO_TRANSFER_CARDS_TYPE.DAYS_DATA) {
				objectCustom.daysData = await daysData(patientFilterData, {
					...totalFilterData,
					totalForPercentage: mainNumPercentage && i === 1 ? mainNumPercentage : totalFilterData.totalForPercentage,
					intermediateTotals,
					currentLevel: actualLevel,
					cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
				});
				objectCustom.daysData = attachLevelTotals(
					objectCustom.daysData,
					{ level1: intermediateTotals.level1, level2: intermediateTotals.level2, level3: intermediateTotals.level3, level4: intermediateTotals.level4, level5: intermediateTotals.level5 },
					actualLevel,
					(p) => p.day ?? p._id ?? p.id,
					{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
				);
				patientFilterData = _.filter(patientFilterData, ({ day }) => _.every([_.includes(cardFilter.daysData, day)]));
			}
			if (ele.type === CO_TRANSFER_CARDS_TYPE.RETURNS_DATA) {
				objectCustom.returnsData = await returnsData(patientFilterData, {
					...totalFilterData,
					totalForPercentage: totalCountData,
					intermediateTotals,
					currentLevel: actualLevel,
					cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
				});

				if (cardFilter.returnsData.length === 1) {
					filter1.wasReturned = returnsDataFilter(cardFilter);
					if (!_.isEmpty(filter1)) {
						patientFilterData = await _.filter(patientFilterData, filter1);
					}
				}
			}

			if (ele.type === CO_TRANSFER_CARDS_TYPE.DOCTOR_DATA) {
				objectCustom.doctorData = await doctorData(patientFilterData, {
					...totalFilterData,
					totalForPercentage: totalCountData,
					intermediateTotals,
					currentLevel: actualLevel,
					cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
				});
				objectCustom.doctorData = attachLevelTotals(
					objectCustom.doctorData,
					{ level1: intermediateTotals.level1, level2: intermediateTotals.level2, level3: intermediateTotals.level3, level4: intermediateTotals.level4, level5: intermediateTotals.level5 },
					actualLevel,
					(p) => p.doctorId ?? p._id ?? p.id,
					{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
				);
				patientFilterData = _.filter(patientFilterData, ({ doctorId }) =>
					_.every([_.includes(cardFilter.doctorData, doctorId)])
				);
			}

			if (ele.type === CO_TRANSFER_CARDS_TYPE.FLOORS_DATA) {
				objectCustom.floorsData = await floorsData(patientFilterData, {
					...totalFilterData,
					totalForPercentage: totalCountData,
					intermediateTotals,
					currentLevel: actualLevel,
					cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
				});
				objectCustom.floorsData = attachLevelTotals(
					objectCustom.floorsData,
					{ level1: intermediateTotals.level1, level2: intermediateTotals.level2, level3: intermediateTotals.level3, level4: intermediateTotals.level4, level5: intermediateTotals.level5 },
					actualLevel,
					(p) => p.floorId ?? p._id ?? p.id,
					{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
				);
				patientFilterData = _.filter(patientFilterData, ({ floorId }) =>
					_.every([_.includes(cardFilter.floorsData, floorId)])
				);
			}

			if (ele.type === CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE_ASS_LIV_DATA) {
				objectCustom.safeDischargeAssLivData = await safeDischargeAssLivData(patientFilterData, {
					...totalFilterData,
					totalForPercentage: totalCountData,
					intermediateTotals,
					currentLevel: actualLevel,
					cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
				});
				objectCustom.safeDischargeAssLivData = maybeAttachTotals(
					objectCustom.safeDischargeAssLivData,
					{ level1: intermediateTotals.level1, level2: intermediateTotals.level2, level3: intermediateTotals.level3, level4: intermediateTotals.level4, level5: intermediateTotals.level5 },
					actualLevel,
					(p) => p.assistantLivId ?? p._id ?? p.id,
					{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
				);

				patientFilterData = _.filter(patientFilterData, ({ assistantLivId }) =>
					_.every([_.includes(cardFilter.safeDischargeAssLivData, assistantLivId)])
				);
			}

			if (ele.type === CO_TRANSFER_CARDS_TYPE.SNF_FACILITY_DATA) {
				objectCustom.snfFacilityData = await snfFacilityData(patientFilterData, {
					...totalFilterData,
					totalForPercentage: totalCountData,
					intermediateTotals,
					currentLevel: actualLevel,
					cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
				});
				objectCustom.snfFacilityData = maybeAttachTotals(
					objectCustom.snfFacilityData,
					{ level1: intermediateTotals.level1, level2: intermediateTotals.level2, level3: intermediateTotals.level3, level4: intermediateTotals.level4, level5: intermediateTotals.level5 },
					actualLevel,
					(p) => p.snfFacilityId ?? p._id ?? p.id,
					{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
				);

				patientFilterData = _.filter(patientFilterData, ({ snfFacilityId }) =>
					_.every([_.includes(cardFilter.snfFacilityData, snfFacilityId)])
				);
			}

			newSavedFilters = [...newSavedFilters, ele.type];
			if (i === priorityData?.length && ele.type !== CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA) {
				updateFacilityPercentageTotal(patientFilterData, forComparison);
			}
		}
		//store.dispatch(setFilterTotal(patientFilterData.length));
		const totalPercentageCount = lockedTotalModified ? lockedTotalModified : patientFilterData.length; //transferType ? patientFilterData?.length : censusAverage

		if (forComparison) {
			const currentFilterTotal = store.getState().communityTransferComparison.filterTotal;
			if (!_.isEqual(currentFilterTotal ?? 0, totalPercentageCount ?? 0)) {
				store.dispatch(setFilterTotalComparison(totalPercentageCount));
			}
		} else {
			const currentFilterTotal = store.getState().communityTransfer.filterTotal;
			if (!_.isEqual(currentFilterTotal ?? 0, totalPercentageCount ?? 0)) {
				store.dispatch(setFilterTotal(totalPercentageCount));
			}
		}
		// Update array data

		if (!_.includes(newSavedFilters, CO_TRANSFER_CARDS_TYPE.INSURANCE_DATA)) {
			objectCustom.insuranceData = await insuranceData(patientFilterData, {
				...totalFilterData,
				totalType: TOTAL_TYPE.FILTER,
				totalForPercentage: totalPercentageCount,
				intermediateTotals,
				currentLevel: finalLevel,
				cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
			});
			objectCustom.insuranceData = attachLevelTotals(
				objectCustom.insuranceData,
				{ level1: intermediateTotals?.level1, level2: intermediateTotals?.level2, level3: intermediateTotals?.level3, level4: intermediateTotals?.level4, level5: intermediateTotals?.level5 },
				finalLevel,
				(p) => p.insuranceId ?? p._id ?? p.id,
				{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
			);
		}
		if (!_.includes(newSavedFilters, CO_TRANSFER_CARDS_TYPE.SIXTY_DAYS_DATA)) {
			objectCustom.sixtyDaysData = await ninetyDaysDataList(sixtyDaysData, patientFilterData, {
				...totalFilterData,
				totalType: TOTAL_TYPE.FILTER,
				totalForPercentage: totalPercentageCount,
				intermediateTotals,
				currentLevel: finalLevel,
				cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
			});
			objectCustom.sixtyDaysData = maybeAttachTotals(
				objectCustom.sixtyDaysData,
				{ level1: intermediateTotals?.level1, level2: intermediateTotals?.level2, level3: intermediateTotals?.level3, level4: intermediateTotals?.level4, level5: intermediateTotals?.level5 },
				finalLevel,
				(p) => p._id ?? p.id,
				{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
			);
		}
		if (!_.includes(newSavedFilters, CO_TRANSFER_CARDS_TYPE.RETURNS_DATA)) {
			objectCustom.returnsData = await returnsData(patientFilterData, {
				...totalFilterData,
				totalType: TOTAL_TYPE.FILTER,
				totalForPercentage: totalPercentageCount,
				intermediateTotals,
				currentLevel: finalLevel,
				cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
			});
		}
		if (!_.includes(newSavedFilters, CO_TRANSFER_CARDS_TYPE.DOCTOR_DATA)) {
			objectCustom.doctorData = await doctorData(patientFilterData, {
				...totalFilterData,
				totalType: TOTAL_TYPE.FILTER,
				totalForPercentage: totalPercentageCount,
				intermediateTotals,
				currentLevel: finalLevel,
				cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
			});
			objectCustom.doctorData = attachLevelTotals(
				objectCustom.doctorData,
				{ level1: intermediateTotals?.level1, level2: intermediateTotals?.level2, level3: intermediateTotals?.level3, level4: intermediateTotals?.level4, level5: intermediateTotals?.level5 },
				finalLevel,
				(p) => p.doctorId ?? p._id ?? p.id,
				{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
			);
		}
		if (!_.includes(newSavedFilters, CO_TRANSFER_CARDS_TYPE.FLOORS_DATA)) {
			objectCustom.floorsData = await floorsData(patientFilterData, {
				...totalFilterData,
				totalType: TOTAL_TYPE.FILTER,
				totalForPercentage: totalPercentageCount,
				intermediateTotals,
				currentLevel: finalLevel,
				cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
			});
			objectCustom.floorsData = attachLevelTotals(
				objectCustom.floorsData,
				{ level1: intermediateTotals?.level1, level2: intermediateTotals?.level2, level3: intermediateTotals?.level3, level4: intermediateTotals?.level4, level5: intermediateTotals?.level5 },
				finalLevel,
				(p) => p.floorId ?? p._id ?? p.id,
				{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
			);
		}
		if (!_.includes(newSavedFilters, CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE_ASS_LIV_DATA)) {
			objectCustom.safeDischargeAssLivData = await safeDischargeAssLivData(patientFilterData, {
				...totalFilterData,
				totalType: TOTAL_TYPE.FILTER,
				totalForPercentage: totalPercentageCount,
				intermediateTotals,
				currentLevel: finalLevel,
				cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
			});
			objectCustom.safeDischargeAssLivData = maybeAttachTotals(
				objectCustom.safeDischargeAssLivData,
				{ level1: intermediateTotals?.level1, level2: intermediateTotals?.level2, level3: intermediateTotals?.level3, level4: intermediateTotals?.level4, level5: intermediateTotals?.level5 },
				finalLevel,
				(p) => p.assistantLivId ?? p._id ?? p.id,
				{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
			);
		}
		if (!_.includes(newSavedFilters, CO_TRANSFER_CARDS_TYPE.DAYS_DATA)) {
			objectCustom.daysData = await daysData(patientFilterData, {
				...totalFilterData,
				totalType: TOTAL_TYPE.FILTER,
				totalForPercentage: totalPercentageCount,
				intermediateTotals,
				currentLevel: finalLevel,
				cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
			});
			objectCustom.daysData = attachLevelTotals(
				objectCustom.daysData,
				{ level1: intermediateTotals?.level1, level2: intermediateTotals?.level2, level3: intermediateTotals?.level3, level4: intermediateTotals?.level4, level5: intermediateTotals?.level5 },
				finalLevel,
				(p) => p.day ?? p._id ?? p.id,
				{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
			);
		}
		if (!_.includes(newSavedFilters, CO_TRANSFER_CARDS_TYPE.SNF_FACILITY_DATA)) {
			objectCustom.snfFacilityData = await snfFacilityData(patientFilterData, {
				...totalFilterData,
				totalType: TOTAL_TYPE.FILTER,
				totalForPercentage: totalPercentageCount,
				intermediateTotals,
				currentLevel: finalLevel,
				cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
			});
			objectCustom.snfFacilityData = maybeAttachTotals(
				objectCustom.snfFacilityData,
				{ level1: intermediateTotals?.level1, level2: intermediateTotals?.level2, level3: intermediateTotals?.level3, level4: intermediateTotals?.level4, level5: intermediateTotals?.level5 },
				finalLevel,
				(p) => p.snfFacilityId ?? p._id ?? p.id,
				{ level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }
			);
		}

		if (dynamicCards.length > 0) {
			for (const item of dynamicCards) {
				let objectCustomRes = {};
				if (!_.includes(newSavedFilters, item?.accessor)) {
					await processDynamicCard(item, patientFilterData, objectCustomRes, {
						...totalFilterData,
						totalType: TOTAL_TYPE.FILTER,
						totalForPercentage: totalPercentageCount,
						intermediateTotals,
						currentLevel: finalLevel,
						cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 },
					});
					if (!_.isEmpty(objectCustomRes)) {
						objectCustom[item?.accessor] = objectCustomRes?.[item?.accessor];
					}
				}
			}
		}
		if (customTabs.length > 0) {
			let customTabsObjRes = {};
			const isCheckNewFilters = true;
			// For combineTab: Always use mainNumPercentage (original data length before filters) to keep percentage consistent
			// Check if any of the custom tabs are combine tabs
			const hasCombineTab = customTabs.some(tab => tab?.type === CUSTOM_TAB_TYPE.combineTab);
			const originalDataLength = totalFilterData?.originalData?.length || patientFilterData.length;
			// For combine tabs, use mainNumPercentage if available, otherwise use originalDataLength
			// For other custom tabs, use totalPercentageCount (filtered data length)
			const totalForPercentageForCombineTabs = hasCombineTab 
				? (mainNumPercentage || originalDataLength || totalFilterData.totalForPercentage)
				: totalPercentageCount;
			
			customTabsObjRes = await getCustomTabsCards(
				patientFilterData,
				customTabs,
				{ ...totalFilterData, totalType: TOTAL_TYPE.FILTER, totalForPercentage: totalForPercentageForCombineTabs, intermediateTotals, currentLevel: finalLevel, cardTitles: { level1: cardTitles.level1, level2: cardTitles.level2, level3: cardTitles.level3, level4: cardTitles.level4, level5: cardTitles.level5 }, forComparison },
				{ sixtyDaysData, dynamicCards, newSavedFilters, isCheckNewFilters, objectCustom, pageType: PAGE_TYPE.COMMUNITY_TRANSFER, diffDashboardPatients, forComparison, customCombineTabData }
			);
			objectCustom = { ...objectCustom, ...customTabsObjRes };
		}
		if (!lockedTotalModified) {
			if (forComparison) {
				const currentLockedByFacility = store.getState().communityTransferComparison.lockedByFacility;
				if (!_.isEqual(currentLockedByFacility ?? [], patientFilterData ?? [])) {
					store.dispatch(setLockedByFacilityComparison(patientFilterData));
				}
			} else {
				const currentLockedByFacility = store.getState().communityTransfer.lockedByFacility;
				if (!_.isEqual(currentLockedByFacility ?? [], patientFilterData ?? [])) {
					store.dispatch(setLockedByFacility(patientFilterData));
				}
			}
		}

	} else {
		batch(async () => {
			const totalCount = mainNumPercentage ? mainNumPercentage : transferType ? patientFilterData?.length : censusAverage;

			forComparison
				? store.dispatch(setFilterTotalComparison(lockedTotalModified ? lockedTotalModified : totalCount))
				: store.dispatch(setFilterTotal(lockedTotalModified ? lockedTotalModified : totalCount));

			if (transferType.length === 0 && lockedTotalModified) {
				var isCensusTotalLocked = true;
				if (forComparison) {
					const currentIsCensusTotalLocked = store.getState().communityTransferComparison.isCensusTotalLocked;
					if (!_.isEqual(currentIsCensusTotalLocked, isCensusTotalLocked)) {
						store.dispatch(setIsCensusTotalLockedComparison(isCensusTotalLocked));
					}
				} else {
					const currentIsCensusTotalLocked = store.getState().communityTransfer.isCensusTotalLocked;
					if (!_.isEqual(currentIsCensusTotalLocked, isCensusTotalLocked)) {
						store.dispatch(setIsCensusTotalLocked(isCensusTotalLocked));
					}
				};
			}
			if (!lockedTotalModified) {
				if (forComparison) {
					const currentLockedByFacility = store.getState().communityTransferComparison.lockedByFacility;
					if (!_.isEqual(currentLockedByFacility ?? [], patientFilterData ?? [])) {
						store.dispatch(setLockedByFacilityComparison(patientFilterData));
					}
				} else {
					const currentLockedByFacility = store.getState().communityTransfer.lockedByFacility;
					if (!_.isEqual(currentLockedByFacility ?? [], patientFilterData ?? [])) {
						store.dispatch(setLockedByFacility(patientFilterData));
					}
				}
			}
			if (lockedTotalModified && !lockedTotalBy) {
				if (transferType.length > 0) {
					const lastValue = transferType[transferType.length - 1];

					forComparison
						? store.dispatch(setLockedTotalByComparison(lastValue))
						: store.dispatch(setLockedTotalBy(lastValue));
				} else {
					forComparison
						? store.dispatch(setLockedTotalByComparison("census"))
						: store.dispatch(setLockedTotalBy("census"));
				}
			}
			updateFacilityPercentageTotal(patientFilterData);
		});
		[
			objectCustom.insuranceData,
			objectCustom.sixtyDaysData,
			objectCustom.returnsData,
			objectCustom.doctorData,
			objectCustom.floorsData,
			objectCustom.safeDischargeAssLivData,
			objectCustom.snfFacilityData,
			objectCustom.daysData,
		] = await Promise.all([
			insuranceData(patientFilterData, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0 }),
			ninetyDaysDataList(sixtyDaysData, patientFilterData, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0 }),
			returnsData(patientFilterData, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0 }),
			doctorData(patientFilterData, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0 }),
			floorsData(patientFilterData, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0 }),
			safeDischargeAssLivData(patientFilterData, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0 }),
			snfFacilityData(patientFilterData, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0 }),
			daysData(patientFilterData, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0 }),
		]);

		if (dynamicCards.length > 0) {
			dynamicCardsObj = await dynamicCardFilter(patientFilterData, dynamicCards, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0 });
		}
		if (customTabs.length > 0) {
			customTabsObj = await getCustomTabsCards(patientFilterData, customTabs, { ...totalFilterData, intermediateTotals: {}, currentLevel: 0, cardTitles: {}, forComparison }, { sixtyDaysData, dynamicCards, pageType: PAGE_TYPE.COMMUNITY_TRANSFER, diffDashboardPatients, forComparison, customCombineTabData });
		}
		objectCustom = { ...objectCustom, ...dynamicCardsObj, ...customTabsObj }
	}

	objectCustom.isComparingAgainstAvgCensus = isComparingAgainstAvgCensus;

	// Page converter uses main dashboard only (comparison runs do not attach this field).
	if (!forComparison) {
		const pageConverterRows = Array.isArray(patientFilterData) ? patientFilterData : [];
		return {
			...objectCustom,
			pageConverterFilteredPatients: _.cloneDeep(pageConverterRows),
		};
	}
	return objectCustom;
}

async function sixtyDaysDataFilter(cardFilter, patientData, ninetyDaysData) {
	let sixtyDaysDataIds = [];
	let sixtyDaysDataFilters = _.filter(ninetyDaysData, ({ _id }) => _.every([_.includes(cardFilter, _id)]));
	if (sixtyDaysDataFilters && sixtyDaysDataFilters?.length > 0) {
		sixtyDaysDataFilters.map((item) => (sixtyDaysDataIds = [...sixtyDaysDataIds, ...item.ids]));
	}
	patientData = _.filter(patientData, ({ _id }) => _.every([_.includes(sixtyDaysDataIds, _id)]));
	return patientData;
}

export async function sixtyDaysDataList(data, patients, totalFilter) {
	const patientIds = patients?.length > 0 ? patients.map((item) => item.id) : [];
	let percentageTotal = totalFilter?.totalForPercentage ? totalFilter.totalForPercentage : patients?.length;
	const res = await updateListTotalValue(data, patientIds, "value", percentageTotal, totalFilter);
	return res;
}

export async function snfFacilityData(data, totalFilter) {
	//SNF Facility Data Cal
	let snfFacilityDBDataGroup = [];
	if (data && data.length > 0) {
		const snfFacilityDBData = _.groupBy(data, "snfFacilityId");
		const originalData = _.groupBy(totalFilter.originalData, "snfFacilityId");
		let percentageTotal = totalFilter?.totalForPercentage ? totalFilter.totalForPercentage : data?.length;

		if (snfFacilityDBData) {
			snfFacilityDBDataGroup = await filterListDataItems(snfFacilityDBData, "snf", percentageTotal, {
				...totalFilter,
				originalData,
			});
		}
	}
	return snfFacilityDBDataGroup;
}

export async function safeDischargeAssLivData(data, totalFilter) {
	//SNF Facility Data Cal
	let safeDischargeAssLivDBDataGroup = [];
	if (data && data.length > 0) {
		const safeDischargeAssLivDBData = _.groupBy(data, "assistantLivId");
		const originalData = _.groupBy(totalFilter.originalData, "assistantLivId");
		let percentageTotal = totalFilter?.totalForPercentage ? totalFilter.totalForPercentage : data?.length;

		if (safeDischargeAssLivDBData) {
			safeDischargeAssLivDBDataGroup = await filterListDataItems(
				safeDischargeAssLivDBData,
				"transferToWhichAssistedLiving",
				percentageTotal,
				{ ...totalFilter, originalData }
			);
		}
	}
	return safeDischargeAssLivDBDataGroup;
}
